import { docReady } from "./utils";
import navbarInit from "./navbar-darken-on-scroll";
import detectorInit from "./detector";

/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(navbarInit);
docReady(detectorInit);
